import React from 'react';
import PropTypes from 'prop-types';

import { VIDEO_COORDINATE_DATA_TYPES } from '../../../../../api/Videos/Videos';

import CreateAnnotationsVideoLine from './CreateAnnotationsVideoLine';
import CreateAnnotationsVideoPoint from './CreateAnnotationsVideoPoint';

const CreateAnnotationMaps = props => {
  const {
    annotations,
    annotationTemplates,
    handleCloseEdit,
    handleNewAnnotationId,
    sizePlayer,
    timeVideoDuration,
    videoSelected,
    ...rest
  } = props;
  const isVideoLine = videoSelected.coordinatesDataType !== VIDEO_COORDINATE_DATA_TYPES.POINT;

  return (
    <>
      {isVideoLine ? (
        <CreateAnnotationsVideoLine
          annotations={annotations}
          annotationTemplates={annotationTemplates}
          handleCloseEdit={handleCloseEdit}
          handleNewAnnotationId={handleNewAnnotationId}
          sizePlayer={sizePlayer}
          timeVideoDuration={timeVideoDuration}
          videoSelected={videoSelected}
          {...rest}
        />
      ) : (
        <CreateAnnotationsVideoPoint
          annotations={annotations}
          annotationTemplates={annotationTemplates}
          handleCloseEdit={handleCloseEdit}
          handleNewAnnotationId={handleNewAnnotationId}
          sizePlayer={sizePlayer}
          timeVideoDuration={timeVideoDuration}
          videoSelected={videoSelected}
          {...rest}
        />
      )}
    </>
  );
};

CreateAnnotationMaps.defaultProps = {};

CreateAnnotationMaps.propTypes = {
  annotations: PropTypes.array.isRequired,
  annotationTemplates: PropTypes.array.isRequired,
  handleCloseEdit: PropTypes.func.isRequired,
  handleNewAnnotationId: PropTypes.func.isRequired,
  sizePlayer: PropTypes.object.isRequired,
  timeVideoDuration: PropTypes.number.isRequired,
  videoSelected: PropTypes.object.isRequired
};

export default CreateAnnotationMaps;
